<div class="modal-content">
    <div class="modal-header text-center">

    </div>
    <div class="modal-body pb-5">
        <img src="assets/img/alert.svg">
        <hr class="w-50 mx-auto">
        <h6 class="mt-2">Estamos teniendo dificultades para comunicarnos</h6>
        <h6 class="mt-2">con nuestros servidores</h6>
    </div>
    <div class="modal-footer">
        <div class="row mx-auto">
            <h6>Espere unos segundos mientras restablecemos la comunicación</h6>
        </div>
    </div>
</div>